import Axios from "../utils/axiosInstance";
import fileSaver from "file-saver";

/**
 * API for getting list of all customer, dealer, backoffice and service engineer for access control
 * @param {*} role will be customer, dealer, backoffice or service engineer
 * @returns list of all users based on role
 */
export const getAccessControlList = (pageNo,role,headers) => {
  return Axios.get(`/access-control/getAllAccessControlDetailsList?role=${role}&pageNo=${pageNo}`, {
    headers
  });
};

// API for updating access control of all customer, dealer, backoffice and service engineer
export const putAccessControlDetails = (payload,headers) => {
  return Axios.put(`/access-control/addAccessControlDetails`, payload, {
    headers
  });
};

// API for updating access control status of all customer, dealer, backoffice and service engineer
export const putAccessControlStatus = (pkAccessControlId, status) => {
  let token = sessionStorage.getItem("token");
  return Axios.put(`/access-control/updateStatusOfAccessControl?pkAccessId=${pkAccessControlId}&status=${status}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
};

// API for getting object of all username, email, mobile no. for validation
export const getAllUserNameEmailMobileNo = () => {
  let token = sessionStorage.getItem("token");
  // return Axios.get(`petrotec/getUserNameEmailMobileNo`, {
  return Axios.get(`/access-control/getUserNameEmailMobileNo`, {
    
    headers: { Authorization: `Bearer ${token}` },
  });
};

// Get API for access control pdf
export const getAccessControlAllPdf = (re) => {
  let fileType = ["Pdf"];
  // let role = ["customer"]
  let token = sessionStorage.getItem("token");
  return Axios.get(`/access-control/getAccessControlPdf?fileType=${fileType}&role=${re}`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "arraybuffer",
  })
  .then((response) => {
    var blob = new Blob([response.data], { type: "application/pdf" });
    fileSaver.saveAs(blob, `accesscontrolreport.pdf`);
  });
};

export const getAccessControlAllExcel = (re) => {
  let fileType = ["Excel"];
  let token = sessionStorage.getItem("token");
  return Axios.get(`/access-control/getAccessControlPdf?fileType=${fileType}&role=${re}`, {
    headers: {Authorization: `Bearer ${token}`},
    responseType: "arraybuffer",
  })
  .then((result) => {
    let blob = new Blob([result.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
    fileSaver.saveAs(blob, "accesscontrolreportexcel.xlsx");
  });
};

// // Get API for dealer pdf
// export const getAccessControlDealerPdf = () => {
//   let fileType = ["Pdf"];
//   let role = ["dealer"]
//   let token = sessionStorage.getItem("token");
//   return Axios.get(`getAccessControlPdf?fileType=${fileType}&role=${role}`, {
//     headers: { Authorization: `Bearer ${token}` },
//     responseType: "arraybuffer",
//   });
// };
// // Get API for back office pdf
// export const getAccessControlBackOfficePdf = () => {
//   let fileType = ["Pdf"];
//   let role = ["back office"]
//   let token = sessionStorage.getItem("token");
//   return Axios.get(`getAccessControlPdf?fileType=${fileType}&role=${role}`, {
//     headers: { Authorization: `Bearer ${token}` },
//     responseType: "arraybuffer",
//   });
// };
